module.exports = __webpack_public_path__ + "img/eg.8d38ceb4.jpg";